export const SENT_FOR_TRANSPORT = 'sent_for_transport';
